import React from 'react'

function Loader() {
  return (
<div class="loader"></div> 
  )
}

export default Loader